export const language_data = [
  { name: 'HTML', period: 23, icon: 'devicon-html5-plain' },
  { name: 'CSS', period: 20, icon: 'devicon-css3-plain' },
  { name: 'JavaScript', period: 18, icon: 'devicon-javascript-plain' },
  { name: 'PHP', period: 12, icon: 'devicon-php-plain' }
];
